module.exports = __webpack_public_path__ + "img/cooperative0_logo31.d972eb40.jpg";